/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { UpdateOrderAction, UpdateOrderActionTypes } from './types';

export interface UpdateOrderState {
  loading: boolean;
  error?: Error;
}

export const initialUpdateOrderState: UpdateOrderState = {
  loading: false,
  error: undefined,
};

export default function updateOrderReducer(state = initialUpdateOrderState, action: UpdateOrderAction) {
  switch (action.type) {
    case UpdateOrderActionTypes.UPDATE_ORDER_REQUEST:
      return update(state, {
        loading: { $set: true },
        $unset: ['error'],
      });

    case UpdateOrderActionTypes.UPDATE_ORDER_SUCCESS:
      return update(state, {
        loading: { $set: false },
        $unset: ['error'],
      });

    case UpdateOrderActionTypes.UPDATE_ORDER_ERROR:
      return update(state, {
        loading: { $set: false },
        error: { $set: action.error },
      });

    case UpdateOrderActionTypes.RESET_ERROR:
      return update(state, {
        $unset: ['error'],
      });

    default:
      return state;
  }
}

